import { AfterViewInit, Component, HostListener, Inject, Input, OnDestroy, PLATFORM_ID, inject } from '@angular/core';
import { CommonModule, isPlatformServer } from '@angular/common';
import { CitiShopPropsService } from '../../utility/citi-shop-props.service';
import { MktCommonModule } from 'src/app/common/mkt-common.module';
import { MktModalService, MktTaggingTransformationService } from 'src/app/core/services';
import { WINDOW, WindowRef } from '@citi-gcg-173875/citi-utils';
import { Subscription } from 'rxjs';

@Component({
  selector: 'static-offers-wall',
  standalone: true,
  imports: [CommonModule, MktCommonModule],
  templateUrl: './static-offers-wall.component.html',
  styleUrl: './static-offers-wall.component.scss'
})
export class StaticOffersWallComponent implements AfterViewInit, OnDestroy {
  @Input({ required: true }) staticOffersWall: any = {};
  csp = inject(CitiShopPropsService);
  modalService = inject(MktModalService);
  platformId = inject(PLATFORM_ID);
  device: string = 'desktop';
  circlesArray: any;
  selectedItem: number;
  modalContinuedSub: Subscription;
  public isMobile: boolean;

  constructor(@Inject(WINDOW) private _window: WindowRef,
  private _mktTaggingTransformationService: MktTaggingTransformationService) {
    this.circlesArray = [0, 1, 2];
    this.selectedItem = 0;
  }

  ngAfterViewInit(): void {
    this.onWindowResize();
  }

  ngOnDestroy(): void {
      this.modalContinuedSub?.unsubscribe();
  }

  @HostListener('window:resize', ['$event'])
  private onWindowResize() {
    if (isPlatformServer(this.platformId)) return;
    const windowWidth = this._window ? this._window?.['innerWidth'] : 0;
    this.isMobile = windowWidth <= 480;
    if (this.csp?.userIsEnrolled() && ((windowWidth >= 600 && windowWidth < 768) || (windowWidth >= 820 && windowWidth <= 1024))) {
      document?.documentElement?.style?.setProperty('--reduce-top-margin', '-30px');
    }
    else {
      document?.documentElement?.style?.setProperty('--reduce-top-margin', '40px');
    }
    const position = (document.querySelector('.logo-container > a')?.getBoundingClientRect()?.left -
      document.querySelector('.logo-container')?.getBoundingClientRect()?.left) + 'px';
    document?.documentElement?.style?.setProperty('--position-left-footnote', position || '10px');
  }

  openModal(event, url) {
    const modalInstance = this.modalService.openModal(event, {
      url: url,
      isExternalLink: true,
      primaryButtonText: 'Continue',
      target: '_blank'
    });
    this.loadTagging(url);
    const handleSub = modalInstance?.onContinue.subscribe(()=>this.handleOnCloseTagging(url));
    this.modalContinuedSub.add(handleSub);
  }

  focusCard(item) {
    this.selectedItem = item;
    let cardElements = <HTMLLinkElement>document.querySelector('#tiles_' + (item * 2));
    cardElements.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
    const instance = setTimeout(() => {
      cardElements.focus();
      clearTimeout(instance);
    }, 500);
  }

  @HostListener("scroll", ['$event'])
  scrollHandler(event) {
    const instance = setTimeout(() => {
      const scrollLeft = document.querySelector('#scroll-box').scrollLeft;
      if (scrollLeft < 290) {
        this.selectedItem = 0;
      } else if (scrollLeft >= 290 && scrollLeft < 580) {
        this.selectedItem = 1;
      }
      else {
        this.selectedItem = 2
      }
      clearTimeout(instance);
    }, 500);
  }

  private loadTagging(url: string): void{
    this._mktTaggingTransformationService.tagMktCompareCards('641_g_Citi_Shop_Landing_Exit_Speedbump',
    this.getTaggingForModal(url));
  }

  private handleOnCloseTagging(url: string): void{
    this._mktTaggingTransformationService.tagMktCompareCards('641_g2_Citi_Shop_Exit_Speedbump_Continue', 
    this.getTaggingForModal(url));
  }

  private getTaggingForModal(url: string): any{
    return {
      "form_type": this.csp.browserName() == 'Microsoft Edge' ? 'Edge' : this.csp.browserName(),
	    "enrollment_status": this.csp.userIsEnrolled() ? "Enrolled" : "Not Enrolled",
      "page_content_detail": url
    };
  }

}
